module.exports = __webpack_public_path__ + "static/media/Actor_Pic.c11a37ea.svg";